import API from "../utilities/LocalApiProxy";

import {
	listDirectory,
	downloadMultiple,
	externalSendMultiple,
} from "./documentActions";

import { openGlobalDialog } from "./globalEditDialogActions";

import {
	beginCopyPasteJob,
	beginCutPasteJob,
	beginDeleteJob,
	beginDuplicationJob,
	handlePermanentDeleteFlow,
} from "./jobProgressActions";

import {
	PASTE_SUCCESS,
	PASTE_FAILURE,
	SET_CHECKBOX,
	CUT_SUCCESS,
	COPY_SUCCESS,
	SET_ALL_CHECKBOXES,
	UNSELECT_ALL,
	OBJECT_AND_FOLDER_DUPLICATE_NAMES_FOUND_SUCCESS,
	CLOSE_GLOBAL_SNACKBAR,
} from "../actions/types";
import { isPreventActionOnDeletedResource } from "./errorActions";
import { listTrash } from "./trashActions";
import { listNonNormalItems } from "./archiveActions";
import { deleteRestoreMultipleMattersFromTrashPage } from "./matterActions";
import { setClientLifecycleStatus } from "./clientActions";
import { NORMAL_LIFECYCLE_STATUS } from "../utilities/lifecycleStatus";

export function setCheckbox(listName, id, checked, type, row) {
	return function (dispatch) {
		dispatch({
			type: SET_CHECKBOX,
			payload: { listName, id, checked, type, row },
		});
	};
}
export function setAllCheckboxes(listName, config) {
	return function (dispatch) {
		dispatch({
			type: SET_ALL_CHECKBOXES,
			payload: { listName, config },
		});
	};
}
export function selectAll() {
	return function () {};
}
export function unselectAll() {
	return function (dispatch) {
		dispatch({ type: UNSELECT_ALL });
	};
}
export function copy(sourceBasepath, sourceDirectoryID) {
	return function (dispatch) {
		dispatch({
			type: COPY_SUCCESS,
			payload: { sourceBasepath, sourceDirectoryID },
		});
	};
}
export function cut(sourceBasepath, sourceDirectoryID) {
	return function (dispatch) {
		dispatch({
			type: CUT_SUCCESS,
			payload: { sourceBasepath, sourceDirectoryID },
		});
	};
}

export function duplicateDocument({
	matterID,
	destinationDirectoryID,
	destinationDirectoryPath,
	backendRoot, //documents, email, notes
	autoRename,
	newObjectNames,
	newDirectoryNames,
	documentObject,
}) {
	return function (dispatch, getState) {
		const multiselect = {
			cut: false,
			duplicate: true,
			clipboard: {
				Object: { ...documentObject },
				Folder: {},
			},
			sourceBasepath: destinationDirectoryPath, // duplicate to the same directory
		};
		handlePasteAndDuplicate({
			matterID,
			destinationDirectoryID,
			destinationDirectoryPath,
			backendRoot,
			autoRename,
			newObjectNames,
			newDirectoryNames,
			multiselect,
		})(dispatch, getState);
	};
}

export function paste({
	matterID,
	destinationDirectoryID,
	destinationDirectoryPath,
	backendRoot, //documents, email, notes
	autoRename,
	newObjectNames,
	newDirectoryNames,
}) {
	return function (dispatch, getState) {
		const { multiselect } = getState();
		handlePasteAndDuplicate({
			matterID,
			destinationDirectoryID,
			destinationDirectoryPath,
			backendRoot,
			autoRename,
			newObjectNames,
			newDirectoryNames,
			multiselect,
		})(dispatch, getState);
	};
}

function getDocumentBrowserUrl(matterID, path) {
	if (matterID > 0) return `/matters/${matterID}/${path}`;
	const [namespace, ...rest] = path.split("/");
	return `/firmDocs/${namespace}/docs/${rest.join("/")}`;
}

function handlePasteAndDuplicate({
	matterID,
	destinationDirectoryID,
	destinationDirectoryPath,
	backendRoot, //documents, email, notes
	autoRename,
	newObjectNames,
	newDirectoryNames,
	multiselect,
}) {
	return function (dispatch, getState) {
		const cameFromCut = multiselect.cut;
		const isDuplicationJob = multiselect.duplicate;
		const sourceBasepath = multiselect.sourceBasepath;
		const items = multiselect.clipboard;

		const objectIDs = Object.keys(items.Object).map(
			(key) => items.Object[key].id
		);
		const directoryIDs = Object.keys(items.Folder).map(
			(key) => items.Folder[key].id
		);

		var endpoint;

		if (backendRoot === "/document") {
			endpoint = cameFromCut ? "/document/move" : "/document/copy";
		} else if (backendRoot === "/email") {
			endpoint = cameFromCut ? "/email/move" : "/email/copy";
		} else if (backendRoot === "/notes") {
			endpoint = cameFromCut ? "/notes/move" : "/notes/copy";
		} else {
			console.error(
				"invalid backendRoot passed to multiselectActions::paste"
			);
			return 0;
		}

		const successCallback = () => {
			var itemType = getSnackbarSuccessNoun(items);
			const verb = cameFromCut
				? "moved"
				: isDuplicationJob
					? "duplicated"
					: "copied";
			const destinationUrl = getDocumentBrowserUrl(
				matterID,
				destinationDirectoryPath
			);
			const normalize = (p) => p.replace(/\/+$/, "");
			const isAtDestination =
				normalize(
					decodeURIComponent(getState().globalSearchbar.location)
				) === normalize(destinationUrl);
			if (isAtDestination) {
				listDirectory(matterID, destinationDirectoryPath)(dispatch);
				dispatch({
					type: PASTE_SUCCESS,
					payload: { sourceBasepath, itemType, verb },
				});
			} else {
				dispatch({
					type: PASTE_SUCCESS,
					payload: { sourceBasepath, itemType, verb, destinationUrl },
				});
			}
		};
		const failureCallback = () => {
			const sourceUrl = getDocumentBrowserUrl(matterID, sourceBasepath);
			const normalize = (p) => p.replace(/\/+$/, "");
			const isAtSource =
				normalize(
					decodeURIComponent(getState().globalSearchbar.location)
				) === normalize(sourceUrl);
			dispatch({
				type: PASTE_FAILURE,
				payload: isAtSource ? {} : { destinationUrl: sourceUrl },
			});
		};
		dispatch({ type: "PASTE_REQUEST" });
		if (isDuplicationJob) {
			beginDuplicationJob(0, successCallback)(dispatch);
		} else if (!cameFromCut && backendRoot !== "/notes") {
			//just open the progress snackbar
			beginCopyPasteJob(0, successCallback)(dispatch);
		} else if (cameFromCut && backendRoot !== "/notes") {
			beginCutPasteJob(0, successCallback)(dispatch);
		}
		API.post(endpoint, {
			body: {
				matterID,
				destinationDirectoryID,
				destinationDirectoryPath,
				objectIDs,
				directoryIDs,
				sourceBasepath,
				autoRename,
				newObjectNames,
				newDirectoryNames,
			},
		})
			.then((res) => {
				if (backendRoot !== "/notes") {
					//a copy or cut that is just individual files or emails (ie no folders)
					//will not return with a jobID, and the page should refresh immediately
					if (res?.mysql?.jobID) {
						var jobID = res.mysql.jobID;

						if (cameFromCut) {
							beginCutPasteJob(
								jobID,
								successCallback,
								failureCallback
							)(dispatch);
						} else {
							beginCopyPasteJob(
								jobID,
								successCallback,
								failureCallback
							)(dispatch);
						}
					} else {
						successCallback();
					}
				} else {
					successCallback();
				}
				/*var itemType = getSnackbarSuccessNoun(items);
				listDirectory(matterID, destinationDirectoryPath)(dispatch);

				dispatch({
					type: PASTE_SUCCESS,
					payload: {
						sourceBasepath,
						itemType,
						verb: cameFromCut ? "moved" : "copied",
					},
				});*/
			})
			.catch(({ lxwErrorCode, lxwErrorData }) => {
				// do we want to catch this error when illegal copy/cut because in trash?
				if (lxwErrorCode === 6500) {
					dispatch({
						type: OBJECT_AND_FOLDER_DUPLICATE_NAMES_FOUND_SUCCESS,
					});
					const { numFolders, numFiles } = lxwErrorData;
					openGlobalDialog(
						{
							label: `${
								numFolders + numFiles
							} Duplicate Items Found`,
							mainText: `There are already ${numFolders} folders and ${numFiles} items in this directory with the same name (they might be in the Trash Bin).`,
							canSubmit: true,
							hideTextfield: true,
							submitButtonLabel: "Rename and Paste",
						},
						() =>
							//call again with autoRename true
							handlePasteAndDuplicate({
								matterID,
								destinationDirectoryID,
								destinationDirectoryPath,
								backendRoot,
								autoRename: true,
								newObjectNames,
								newDirectoryNames,
								multiselect,
							})(dispatch, getState),
						() => ({ canSubmit: true }),
						() => {
							dispatch({ type: CLOSE_GLOBAL_SNACKBAR });
						}
					)(dispatch);
				} else if (isPreventActionOnDeletedResource(lxwErrorCode)) {
					// handled in errorActions
					return;
				} else {
					failureCallback();
				}
			});
	};
}
function getSnackbarSuccessNoun(selectedItems) {
	// wanted the display name to change from File to Document, but File is the key in the object and it is referenced in the backend
	// changing everything to Document seemed like it could cause issues
	// var IDs = { Folder: [], File: [], Email: [], Note: [] };
	const objectDisplayNameMap = {
		File: "Document",
		Email: "Email",
		Note: "Note",
		Folder: "Folder",
		Client: "Client",
		Matter: "Matter",
	};
	var itemType = "Object";
	var numObjects = Object.keys(selectedItems.Object).length;
	var numFolders = Object.keys(selectedItems.Folder).length;
	if (numObjects === 0) {
		itemType = "Folder" + (numFolders > 1 ? "s" : "");
	} else {
		if (numFolders === 0) {
			const objectKey =
				selectedItems.Object[Object.keys(selectedItems.Object)[0]].type;
			itemType =
				objectDisplayNameMap[objectKey] + (numObjects > 1 ? "s" : "");
		} else {
			itemType = "Objects";
		}
	}
	return itemType;
}
export function deleteMultiselect(selectedItems, matterID, sourceBasepath) {
	return function (dispatch) {
		deleteRestoreItems({
			selectedItems,
			matterID,
			sourceBasepath,
			action: "DELETE",
			deleteIfTrue: true,
			callback: () => listDirectory(matterID, sourceBasepath)(dispatch),
		})(dispatch);
	};
}
export function restoreMultiselect(selectedItems, matterID, sourceBasepath) {
	return function (dispatch) {
		deleteRestoreItems({
			selectedItems,
			matterID,
			sourceBasepath,
			action: "RESTORE_FROM_TRASH",
			deleteIfTrue: false,
			callback: () => listDirectory(matterID, sourceBasepath)(dispatch),
		})(dispatch);
	};
}
export function restoreFromArchiveMultiselect(
	selectedItems,
	matterID,
	sourceBasepath
) {
	return function (dispatch) {
		deleteRestoreItems({
			selectedItems,
			matterID,
			sourceBasepath,
			action: "RESTORE_FROM_ARCHIVE",
			deleteIfTrue: false,
			callback: () => listDirectory(matterID, sourceBasepath)(dispatch),
		})(dispatch);
	};
}
export function archiveMultiselect(selectedItems, matterID, sourceBasepath) {
	return function (dispatch) {
		deleteRestoreItems({
			selectedItems,
			matterID,
			sourceBasepath,
			action: "ARCHIVE",
			deleteIfTrue: false,
			callback: () => listDirectory(matterID, sourceBasepath)(dispatch),
		})(dispatch);
	};
}

function determineSourceBasepath(trashPageContext) {
	if (trashPageContext === "docs") {
		return "trash/docs/";
	} else if (trashPageContext === "email") {
		return "trash/email/";
	} else if (trashPageContext === "notes") {
		return "trash/notes/";
	} else if (trashPageContext === "matters") {
		return "trash/matters/";
	} else if (trashPageContext === "clients") {
		return "trash/clients/";
	} else {
		console.error("Invalid trashPageContext");
	}
}

export function deleteMultiselectOnArchivePage({
	selectedItems,
	matterID,
	basepath,
	itemType,
}) {
	return function (dispatch) {
		deleteRestoreItems({
			selectedItems,
			sourceBasepath: `archive/${itemType}/`,
			action: "DELETE",
			deleteIfTrue: true,
			callback: () =>
				listNonNormalItems({
					matterID,
					basepath,
					lifecycleStatusToGet: "archive",
					itemType,
				})(dispatch),
		})(dispatch);
	};
}

export function archiveMultiselectOnArchivePage({
	selectedItems,
	matterID,
	basepath,
	itemType,
}) {
	return function (dispatch) {
		deleteRestoreItems({
			selectedItems,
			sourceBasepath: `trash/${itemType}/`,
			action: "ARCHIVE",
			deleteIfTrue: false,
			callback: () =>
				listNonNormalItems({
					matterID,
					basepath,
					lifecycleStatusToGet: "trash",
					itemType,
				})(dispatch),
		})(dispatch);
	};
}

export function restoreFromArchiveMultiselectOnArchivePage({
	selectedItems,
	matterID,
	basepath,
	itemType,
}) {
	return function (dispatch) {
		deleteRestoreItems({
			selectedItems,
			sourceBasepath: `archive/${itemType}/`,
			action: "RESTORE_FROM_ARCHIVE",
			deleteIfTrue: false,
			callback: () =>
				listNonNormalItems({
					matterID,
					basepath,
					lifecycleStatusToGet: "archive",
					itemType,
				})(dispatch),
		})(dispatch);
	};
}

export function restoreFromTrashMultiselectOnArchivePage({
	selectedItems,
	matterID,
	basepath,
	itemType,
}) {
	return function (dispatch) {
		deleteRestoreItems({
			selectedItems,
			sourceBasepath: `trash/${itemType}/`,
			action: "RESTORE_FROM_TRASH",
			deleteIfTrue: false,
			callback: () =>
				listNonNormalItems({
					matterID,
					basepath,
					lifecycleStatusToGet: "trash",
					itemType,
				})(dispatch),
		})(dispatch);
	};
}

export function restoreMultiSelectTrashPage({
	selectedItems,
	trashPageContext,
}) {
	return function (dispatch) {
		// matters and clients have their own lifecycle endpoints, the /multi endpoints do not accept them
		const selectedObjectIDs = Object.values(selectedItems.Object).map(
			(item) => item.id
		);
		if (trashPageContext === "matters") {
			deleteRestoreMultipleMattersFromTrashPage({
				matterIDs: selectedObjectIDs,
				isDeleted: 0,
			})(dispatch);
			return;
		}
		if (trashPageContext === "clients") {
			setClientLifecycleStatus({
				clientIDs: selectedObjectIDs,
				lifecycleStatus: NORMAL_LIFECYCLE_STATUS,
				location: "trashBin",
			})(dispatch);
			return;
		}
		deleteRestoreItems({
			selectedItems,
			matterID: null,
			sourceBasepath: determineSourceBasepath(trashPageContext),
			deleteIfTrue: false,
			action: "RESTORE_FROM_TRASH",
			callback: () => listTrash({ trashPageContext })(dispatch),
		})(dispatch);
	};
}

export function externalSendAllMultiselect(
	selected,
	parentDirectoryPath,
	matterID,
	recipients,
	message,
	passwordProtectShare
) {
	console.log(selected);
	console.log("@@@downloadAllMultiselect");
	console.log(selected);
	console.log(parentDirectoryPath);
	console.log(matterID);
	return function (dispatch) {
		var selectedItems = {
			Folder: Object.keys(selected.Folder),
			manifestItemType: selected.manifestItemType,
			Object: Object.keys(selected.Object),
		};
		console.log("@@@externalSendAllMultiselect>dispatch");
		console.log(matterID);
		externalSendMultiple(
			selectedItems,
			parentDirectoryPath,
			matterID,
			recipients,
			message,
			passwordProtectShare
		)(dispatch);
	};
}

export function downloadAllMultiselect(
	selected,
	objectTypesToInclude,
	parentDirectoryPath,
	matterID
) {
	return function (dispatch) {
		var selectedItems = {
			Folder: Object.keys(selected.Folder),
			manifestItemType: selected.manifestItemType,
			Object: Object.keys(selected.Object),
		};
		downloadMultiple(
			selectedItems,
			objectTypesToInclude,
			parentDirectoryPath,
			matterID
		)(dispatch);
	};
}

function performDeleteRestore({
	IDs,
	objectType,
	action,
	itemType,
	sourceBasepath,
	callback,
	acknowledgedByUser = false,
}) {
	return function (dispatch) {
		function success() {
			dispatch({
				type: `${action}_SUCCESS`,
				payload: {
					sourceBasepath,
					itemType,
				},
			});
			callback();
		}
		function failure() {
			dispatch({
				type: `${action}_FAILURE`,
			});
		}
		dispatch({ type: `${action}_REQUEST` });
		let apiEndpoint =
			action === "DELETE"
				? "/multi/v2/delete"
				: action === "ARCHIVE"
					? "/multi/v2/archive"
					: "/multi/v2/restore";
		API.post(apiEndpoint, {
			body: {
				IDs,
				objectType,
				...(acknowledgedByUser && { acknowledgedByUser }),
			},
		})
			.then((res) => {
				if (res.mysql && res.mysql.jobID) {
					beginDeleteJob({
						jobID: res.mysql.jobID,
						successCallback: success,
						failureCallback: failure,
						action,
					})(dispatch);
				} else {
					success();
				}
			})
			.catch((err) => {
				if (err.lxwErrorCode === 9409) {
					const warningPartsByAction = {
						DELETE: {
							conflictLocation: "Archive",
							actionPhrase: "moving the item(s) to the Trash Bin",
							resultState: "the Trash Bin",
						},
						RESTORE_FROM_TRASH: {
							conflictLocation: "Archive",
							actionPhrase: "restoring the item(s)",
							resultState: "an Active state",
						},
						RESTORE_FROM_ARCHIVE: {
							conflictLocation: "Trash Bin",
							actionPhrase: "restoring the item(s)",
							resultState: "an Active state",
						},
						ARCHIVE: {
							conflictLocation: "Trash Bin",
							actionPhrase: "moving the item(s) to Archive",
							resultState: "an Archived state",
						},
					};
					const { conflictLocation, actionPhrase, resultState } =
						warningPartsByAction[action];
					openGlobalDialog(
						{
							label: "Warning",
							mainText: `The selected item(s) include a mix of items that are in and not in the ${conflictLocation}. As items cannot be both Archived and in the Trash Bin, ${actionPhrase} will remove any items from the ${conflictLocation} and place them in ${resultState}. Do you want to continue?`,
							canSubmit: true,
							hideTextfield: true,
							submitButtonLabel: "Continue",
						},
						() =>
							performDeleteRestore({
								IDs,
								objectType,
								action,
								itemType,
								sourceBasepath,
								callback,
								acknowledgedByUser: true,
							})(dispatch),
						() => ({ canSubmit: true }),
						() => {
							// remove the loading blocker
							dispatch({
								type: `${action}_CANCELED`,
							});
						}
					)(dispatch);
					return;
				}
				if (isPreventActionOnDeletedResource(err.lxwErrorCode)) {
					return;
				}
				failure();
			});
	};
}

function deleteRestoreItems({
	selectedItems,
	// matterID,
	sourceBasepath,
	action,
	callback,
}) {
	return function (dispatch) {
		// matters and clients are not accepted by the /multi endpoints, they use their own lifecycle endpoints
		var IDs = {
			Folder: [],
			File: [],
			Email: [],
			Note: [],
		};
		Object.keys(selectedItems.Object).forEach((key) => {
			IDs[selectedItems.Object[key].type].push(
				selectedItems.Object[key].id
			);
		});
		Object.keys(selectedItems.Folder).forEach((key) => {
			IDs[selectedItems.Folder[key].type].push(
				selectedItems.Folder[key].id
			);
		});
		var itemType = getSnackbarSuccessNoun(selectedItems);
		var objectType = determineObjectType(sourceBasepath);

		performDeleteRestore({
			IDs,
			objectType,
			action,
			itemType,
			sourceBasepath,
			callback,
		})(dispatch);
	};
}

const trashPageContextMultiselectMap = {
	docs: "selectedTrashDocuments",
	email: "selectedTrashEmails",
	notes: "selectedTrashNotes",
	matters: "selectedTrashMatters",
	clients: "selectedTrashClients",
};
export function generatePermanentDeleteManifestForMultiselect({
	trashPageContext,
}) {
	return function (dispatch, getState) {
		const { multiselect } = getState();
		const selectedItems =
			multiselect[trashPageContextMultiselectMap[trashPageContext]];

		let IDs = {
			Folder: [],
			File: [],
			Email: [],
			Note: [],
			Matter: [],
			Client: [],
		};
		Object.keys(selectedItems.Object).forEach((key) => {
			IDs[selectedItems.Object[key].type].push(
				selectedItems.Object[key].id
			);
		});
		Object.keys(selectedItems.Folder).forEach((key) => {
			IDs[selectedItems.Folder[key].type].push(
				selectedItems.Folder[key].id
			);
		});
		let objectTypesToIncludeObject = {
			Document: 0,
			Email: 0,
			Note: 0,
			Folder: 0,
			Matter: 0,
			Client: 0,
		};
		if (IDs.File.length > 0) {
			objectTypesToIncludeObject.Document = 1;
		}
		if (IDs.Email.length > 0) {
			objectTypesToIncludeObject.Email = 1;
		}
		if (IDs.Note.length > 0) {
			objectTypesToIncludeObject.Note = 1;
		}
		if (IDs.Matter.length > 0) {
			// include all object types
			objectTypesToIncludeObject.Document = 1;
			objectTypesToIncludeObject.Email = 1;
			objectTypesToIncludeObject.Note = 1;
		}
		if (IDs.Client.length > 0) {
			// only include client
			objectTypesToIncludeObject.Client = 1;
		}
		if (IDs.Folder.length > 0) {
			if (trashPageContext === "docs") {
				objectTypesToIncludeObject.Document = 1;
			}
			if (trashPageContext === "email") {
				objectTypesToIncludeObject.Email = 1;
			}
			if (trashPageContext === "notes") {
				objectTypesToIncludeObject.Note = 1;
			}
		}
		const objectTypesToInclude = Object.entries(objectTypesToIncludeObject)
			.filter(([, value]) => value === 1)
			.map(([key]) => key);

		API.post("/trash/generatePermanentDeleteManifest", {
			body: { trashPageContext, IDs, objectTypesToInclude },
		})
			.then((res) => {
				if (res?.mysql?.jobID) {
					handlePermanentDeleteFlow({
						jobID: res.mysql.jobID,
						objectIDs: IDs,
						trashPageContext,
					})(dispatch, getState);
				}
			})
			.catch(() => {});
	};
}
function determineObjectType(sourceBasepath) {
	if (sourceBasepath.indexOf("docs/") === 0) {
		return "Documents";
	} else if (sourceBasepath.indexOf("public/") === 0) {
		return "Documents";
	} else if (sourceBasepath.indexOf("private/") === 0) {
		return "Documents";
	} else if (sourceBasepath.indexOf("email/") === 0) {
		return "Emails";
	} else if (sourceBasepath.indexOf("notes/") === 0) {
		return "Notes";
	} else if (sourceBasepath.indexOf("trash/docs/") === 0) {
		return "Documents";
	} else if (sourceBasepath.indexOf("trash/public/") === 0) {
		return "Documents";
	} else if (sourceBasepath.indexOf("trash/private/") === 0) {
		return "Documents";
	} else if (sourceBasepath.indexOf("trash/email/") === 0) {
		return "Emails";
	} else if (sourceBasepath.indexOf("trash/notes/") === 0) {
		return "Notes";
	} else if (sourceBasepath.indexOf("archive/docs/") === 0) {
		return "Documents";
	} else if (sourceBasepath.indexOf("archive/email/") === 0) {
		return "Emails";
	} else if (sourceBasepath.indexOf("archive/notes/") === 0) {
		return "Notes";
	} else {
		return "Unknown";
	}
}
